import React, { Component } from "react";
import {
  GridItem,
  Button,
  Grid
} from "@sainsburys-tech/fable";
import { Link, Redirect } from "react-router-dom";
import StoreZoneList from "../StoreZoneList";
import StoreDeleteModal from "../StoreZoneDeleteModal";
import StoreZoneEditModal from "../StoreZoneEditModal";
import mapSceneLevel from "../../model/store-commissioning/mapSceneLevel";
import * as zoneTypeKeys from "../../model/lighting-zone-types/zoneTypeKeys.js";
import { Event } from "../Tracking";

const mapZoneConfiguration = (store, scenes) => {
  if (store.storeConfiguration != null) {
    return store.storeConfiguration.zones.map(zone => {
      return {
        zone: {
          name: zone.zone.name,
          zoneId: zone.zone.zoneId,
          zoneType: zone.zone.zoneType
        },

        scenes: mapScenes(store.zoneConfiguration, zone, scenes)
      };
    });
  }
};

const mapScenes = (zoneConfigurationToMap, zone, scenes) => {
  const zoneConfiguration = zoneConfigurationToMap.find(
    zoneConfiguration => zoneConfiguration.zone.zoneId === zone.zone.zoneId
  );
  if (!zoneConfiguration) {
    return scenes.scenes.map(scene => {
      return {
        scene: {
          name: scene.name,
          description: scene.description
        },
        sceneLevel: null
      };
    });
  }

  return zoneConfiguration.scenes.map(scene => {
    return {
      scene: {
        name: scene.scene.name,
        description: scene.scene.description
      },
      sceneLevel: mapSceneLevel(scene, zoneConfiguration.zone.zoneType)
    };
  });
};

class StoreZonesPage extends Component {
  state = {
    zoneIdToDelete: undefined,
    editConfirmationOpen: false,
    zoneToEdit: {
      name: null,
      zoneId: null
    },
    redirectToEditZone: false
  };

  handleDeleteZoneSuccess = () => {
    this.props.onZoneDelete();
  };

  render() {
    const zonesConfiguration = mapZoneConfiguration(
      this.props.store,
      this.props.scenes
    );

    const allScenesSet = zonesConfiguration
      ? zonesConfiguration.every(x =>
          x.scenes.every(s => s.sceneLevel !== null)
        )
      : false;

    const deleteZone = (e, storeId, zoneId, zoneName) => {
      e.preventDefault();
      this.setState({
        deleteConfirmationOpen: true,
        zoneIdToDelete: zoneId,
        nameOfZoneToDelete: zoneName
      });
    };

    const editZone = (zoneId, zoneName) => {
      const matchingCbusZoneConfiguration = this.props.store.zoneConfiguration.find(
        z => z.zone.zoneId === zoneId && z.zone.type === zoneTypeKeys.CBUS
      );

      const zoneHasSceneValues = matchingCbusZoneConfiguration !== undefined;

      this.setState({
        editConfirmationOpen: zoneHasSceneValues,
        zoneToEdit: {
          name: zoneName,
          zoneId: zoneId
        },
        redirectToEditZone: !zoneHasSceneValues
      });
    };

    const handleCloseEditModal = () => {
      this.setState({
        editConfirmationOpen: false,
        zoneToEdit: {
          zoneId: null,
          name: null
        }
      });
    };

    const closeDialog = () => {
      this.setState({
        deleteConfirmationOpen: false,
        zoneIdToDelete: undefined,
        nameOfZoneToDelete: undefined
      });
    };

    if (this.state.redirectToEditZone) {
      return (
        <Redirect
          to={
            `/lighting` +
            `/stores/` +
            this.props.store.store.storeId +
            `/zones/` +
            this.state.zoneToEdit.zoneId +
            `/configuration`
          }
          push={true}
        />
      );
    }

    return (
      <div>
        <StoreDeleteModal
          open={this.state.deleteConfirmationOpen}
          closeDialog={closeDialog}
          storeId={this.props.store.store.storeId}
          zoneId={this.state.zoneIdToDelete}
          zoneName={this.state.nameOfZoneToDelete}
          onDeleteSuccess={this.handleDeleteZoneSuccess}
        />
        <StoreZoneEditModal
          open={this.state.editConfirmationOpen}
          onClose={handleCloseEditModal}
          onEdit={() => this.setState({ redirectToEditZone: true })}
          storeId={this.props.store.store.storeId}
          zoneToEdit={this.state.zoneToEdit}
        />
        <Grid cols={{ xs: 1, lg: 2 }}>
          <GridItem colSpan={{ xs: 1, lg: 1 }}>
            <h3>Add zones for the store and then add scene values </h3>
          </GridItem>
          <GridItem colSpan={{ xs: 1, lg: 1 }} className="fable:text-right">
            <Link
              to={{
                pathname: `/lighting/stores/${this.props.store.store.storeId}/zones/add`
              }}
            >
              <Button
                variant="secondary"
                onClick={() =>
                  Event("Commissioning Event", "Add New Zone", "(not set)")
                }
              >
                Add new zone
              </Button>
            </Link>
          </GridItem>
          <GridItem colSpan={{ xs: 1, lg: 1 }}>
            <p>
              Zones will appear here once added to the store. Once a zone has
              been added then add scene values.
            </p>
          </GridItem>
          {this.props.store.storeConfiguration !== null &&
            this.props.store.storeConfiguration.zones.length > 0 && (
              <React.Fragment>
                <GridItem colSpan={{ xs: 1, lg: 1 }}>
                  <StoreZoneList
                    zonesConfiguration={zonesConfiguration}
                    scenes={this.props.scenes.scenes}
                    storeId={this.props.store.store.storeId}
                    deleteStoreZone={deleteZone}
                    editStoreZone={editZone}
                  />
                </GridItem>
                <GridItem colSpan={{ xs: 1, lg: 1 }} className="fable:p-16">
                  <Link
                    to={{
                      pathname: `/lighting/stores/${this.props.store.store.storeId}/commissioning/test-scenes`
                    }}
                  >
                    <Button variant="primary" fullWidth disabled={!allScenesSet}>
                      Test scenes
                    </Button>
                  </Link>
                </GridItem>
              </React.Fragment>
            )}
        </Grid>
      </div>
    );
  }
}

export default StoreZonesPage;
